import { useState, FC } from 'react';
import { Button, InputBase, ThemeProvider, Tooltip, createTheme } from '@mui/material';
import React from 'react';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { docGeniusPalette } from 'styles/partials/colors';

const whiteTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#FFFFFF',
    },
    secondary: {
      main: docGeniusPalette.primaryBlue,
    },
  },
});

type SearchBarProps = {
  value: string;
  disabled?: boolean;
  placeholder?: string;
  onSearch: (query: string) => void;
};

export const SearchBar: FC<SearchBarProps> = ({ value, disabled, placeholder, onSearch }: SearchBarProps) => {
  const [val, setVal] = useState<string>(value);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setVal(input);
    if (input === '') onSearch('');
  };

  const handleClick = () => {
    onSearch(val);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      onSearch(val);
    }
  };

  return (
    <ThemeProvider theme={whiteTheme}>
      <InputBase
        disabled={disabled}
        endAdornment={
          <Tooltip title='Search' arrow>
            <Button
              disableRipple
              disabled={disabled}
              sx={{
                backgroundColor: 'white',
                border: '1px solid #265183',
                borderRadius: '0 8px 8px 0',
                color: '#265183',
                height: '48px',
                padding: 0,
                ':active': {
                  backgroundColor: '#B3C2DA',
                },
                ':hover': {
                  border: '1px solid #265183',
                  backgroundColor: '#F6F8FB',
                },
                ':disabled': {
                  backgroundColor: '#ECECED',
                  border: '1px solid #B5B5B6',
                },
              }}
              variant='outlined'
              onClick={handleClick}
            >
              <SearchRoundedIcon color={disabled ? 'disabled' : 'secondary'} />
            </Button>
          </Tooltip>
        }
        fullWidth
        placeholder={placeholder}
        sx={{
          '.MuiInputBase-input': {
            border: '1px solid #B7B9C0',
            borderRight: 'none',
            borderRadius: '8px 0 0 8px',
            padding: '12px 16px',
            ':disabled': {
              backgroundColor: '#ECECED',
              border: '1px solid #B5B5B6',
            },
          },
        }}
        type='search'
        value={val}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
    </ThemeProvider>
  );
};
